<div class="modal-header">
    <h2 class="modal-title">User Detail</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form [formData]="user" [colCount]="1" [validationGroup]="validationGroup" [readOnly]="readOnly" *ngIf="user" autocomplete="off">
                <dxi-item itemType="group">
                    <dxi-item dataField="userName" [label]="{ text: 'Username' }">
                        <dxi-validation-rule type="required" message="Username Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="custom" message="Username is already in use" [validationCallback]="validateUsername"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item [label]="{ text: 'Linked Employee' }" *ngIf="filter">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="filter.linkedEmployeeId"
                                [items]="employees"
                                valueExpr="id"
                                displayExpr="displayName"
                                searchEnabled="true"
                                showClearButton="false"
                            ></dx-select-box>
                        </div>
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="newPassword" [editorOptions]="{ name: 'new-password' }">
                        <dxi-validation-rule
                            type="custom"
                            message="Password must be at least 8 characters in length"
                            [validationCallback]="validatePassword"
                            reevaluate="true"
                        ></dxi-validation-rule>
                        <dxi-validation-rule
                            type="custom"
                            message="Password required for new users"
                            [validationCallback]="validatePasswordRequired"
                            reevaluate="true"
                        ></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item [label]="{ text: 'Roles' }">
                        <div *dxTemplate>
                            <dx-list
                                [items]="roles"
                                keyExpr="id"
                                [(selectedItemKeys)]="selectedRoleIds"
                                selectionMode="multiple"
                                [showSelectionControls]="true"
                                itemTemplate="listItem"
                            >
                                <div *dxTemplate="let item of 'listItem'">
                                    {{ item.name }}
                                </div>
                            </dx-list>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>

    <div>
        <dx-toast message="Changes Saved!" type="success" [displayTime]="500" [maxWidth]="300" [position]="'bottom right'" [(visible)]="isToastVisible"> </dx-toast>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="save()" [hidden]="readOnly">Save</button>
    <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
